export function buildProfilesTableModel(dtoList = []) {
  return dtoList.map((item) => ({
    key: item.key,
    id: item.id,
    name: item.name,
    email: item.email,
    status: item.status,
    invalid: item.invalid === true,
    country: item.country,
    assignedToId: item.assignedToId,
    assignedToName: item.assignedToName,
    createdAt: item.createdAt,
  }));
}
